(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxCustomContentWidget', {
		bindings: {
			widgetId: '@',
		},
		controller: MxCustomContentWidgetCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-custom-content-widget/mx-custom-content-widget.html',
	});

	MxCustomContentWidgetCtrl.$inject = [
		'$q',
		'$attrs',
		'$scope',
		'$interpolate',
		'mx.SolutionBuilderAgent.ContentWidgetService',
		'mx.SolutionBuilderAgent.ControlDescriptorService',
		'mx.SolutionBuilderAgent.DataModelService',
	];

	function MxCustomContentWidgetCtrl($q, $attrs, $scope, $interpolate, contentWidgetService, controlDescriptorService, dataModelService) {
		var vm = this;
		var controlDescriptorId;
		var freeDataSourceDefer;
		var watchers;

		vm.$onInit = function () {
			init();
		};

		vm.$onDestroy = function () {
			destroy();
		};

		vm.$onChanges = function (changes) {
			if (changes.widgetId && !changes.widgetId.isFirstChange()) {
				destroy();
				init();
			}
		};

		return vm;

		function init() {
			freeDataSourceDefer = $q.defer();
			watchers = [];

			if (!vm.widgetId) {
				return;
			}

			contentWidgetService
				.getHtml(vm.widgetId)
				.then(function (data) {
					controlDescriptorId = data.ControlDescriptorId;

					if (Array.isArray(data.Template.Views) && data.Template.Views.length > 0) {
						vm.view = data.Template.Views[0];
						vm.view.widgetId = data.Id;
					}
					vm.widget = {
						id: data.Id,
						view: vm.view,
					};

					vm.serviceContextInfo = {
						widgetId: vm.widgetId,
						viewName: vm.view?.Key,
					};

					if (data.Template.DataModelExtensions) {
						try {
							vm.widget.extensions = JSON.parse(data.Template.DataModelExtensions);
						} catch (e) {
							mx.console.warn(e);
						}
					}

					return controlDescriptorId ? controlDescriptorService.getProperties(controlDescriptorId) : $q.when([]);
				})
				.then(function (properties) {
					var staticData = {
						Context: {
							WidgetId: vm.widget.id,
						},
						WidgetAttributes: initWidgetAttributes(properties),
					};
					return dataModelService.loadDataModel(vm.widget.extensions, staticData, undefined, freeDataSourceDefer.promise);
				})
				.then(function (dataModel) {
					vm.dataModel = dataModel;
				});
		}

		function destroy() {
			freeDataSourceDefer?.resolve(true);
			watchers?.forEach(function (w) {
				w();
			});
			freeDataSourceDefer = null;
			watchers = null;
		}

		function initWidgetAttributes(properties) {
			var widgetAttributes = {};
			properties.forEach(function (property) {
				if (property.direction === mx.SolutionBuilderAgent.DataModelPropertyDirection.IN) {
					initOneWayWidgetAttribute(property, widgetAttributes);
				} else if (property.direction === mx.SolutionBuilderAgent.DataModelPropertyDirection.BOTH) {
					initTwoWayWidgetAttribute(property, widgetAttributes);
				}
			});
			return widgetAttributes;
		}

		function initOneWayWidgetAttribute(property, widgetAttributes) {
			var value = $attrs[property.camelCasedName] && $interpolate($attrs[property.camelCasedName])($scope.$parent);

			watchers.push(
				$attrs.$observe(property.camelCasedName, function (interpolatedValue) {
					value = interpolatedValue;
				})
			);
			Object.defineProperty(widgetAttributes, property.camelCasedName, {
				enumerable: true,
				configurable: true,
				get: function () {
					return value;
				},
				set: function (newValue) {
					value = newValue;
				},
			});
		}

		function initTwoWayWidgetAttribute(property, widgetAttributes) {
			var attributeValue = $attrs[property.camelCasedName];
			if (!attributeValue) {
				return;
			}

			widgetAttributes[property.camelCasedName] = $scope.$parent.$eval(attributeValue);

			watchers.push(
				$scope.$parent.$watch(attributeValue, function (newValue) {
					widgetAttributes[property.camelCasedName] = newValue;
				})
			);

			var path = attributeValue.split('.');
			watchers.push(
				$scope.$parent.$watch(
					function () {
						return widgetAttributes[property.camelCasedName];
					},
					function (newValue) {
						if (path.length <= 0) {
							return;
						}
						if (path.length === 1) {
							$scope.$parent[path[0]] = newValue;
						}
						var item = $scope.$parent;
						var unfound = path.slice(0, path.length - 1).some(function (step) {
							item = item[step];
							return typeof item === 'undefined';
						});

						if (!unfound) {
							var prevValue = item[path[path.length - 1]];
							if (prevValue !== newValue) {
								item[path[path.length - 1]] = newValue;
							}
						}
					}
				)
			);

			//Todo: refactor 'data-model-calculated-property.js' , line:" if (calcProperty.descriptor.Name !== mx.SolutionBuilderAgent.DataModelSystemProperty.Item || localParentPath === parentObjectPath ) "
			// Todo: use recursive setter
			/*Object.defineProperty(widgetAttributes, property.camelCasedName, {
				enumerable: true,
				configurable: true,
				get: function () {
					return value;
				},
				set: function (newValue) {
					value = newValue;
					if (path.length <= 0) {
						return;
					}
					if (path.length === 1) {
						$scope.$parent[path[0]] = newValue;
					}
					var item = $scope.$parent;
					var unfound = path.slice(0, path.length - 1).some(function (step) {
						item = item[step];
						return typeof item === 'undefined';
					});

					if (!unfound) {
						item[path[path.length - 1]] = newValue;
					}
				}
			});*/
		}
	}
})();
